import React, {useEffect, forwardRef} from 'react';
import newsActions from '../../actions/news.actions';
import NewsItem from './components/NewsItem';
import NewsPromoItem from './components/NewsPromoItem';
import {Message} from 'epic-diesel-common';
import {LoadMore} from '../../components';
import {useDispatch} from 'react-redux';
import {NewsState} from '../../reducers/news.reducer';
import {NewsViewProps} from './NewsView';

//@ts-ignore
import styles from './News.pcss';

export interface NewsProps extends NewsViewProps {
    newsState: NewsState;
}

const CODES = {
    header: 'epic.affiliate.nav.news'
};

const News = forwardRef<HTMLTableSectionElement, NewsProps>(
    ({newsState, configState}, forwardRef) => {
        const dispatch = useDispatch();
        const {locale} = configState || {};
        const {posts = [], loading, lastFetchFailed, hasFetchedAllPosts} = newsState || {};
        const promoPosts = posts.slice(0, 2);
        const regPosts = posts.slice(promoPosts.length, posts.length);

        const getNews = data => {
            dispatch(newsActions.getNews(data));
        };

        const loadMorePosts = () => {
            getNews({locale, cursor: posts.length});
        };

        useEffect(() => {
            if (!newsState.lastFetch) {
                getNews({locale});
            }
        }, []);

        return (
            <section ref={forwardRef} className={styles.news}>
                <h2>
                    <Message code={CODES.header} />
                </h2>

                {promoPosts.length > 0 && (
                    <ul className={styles.promoList}>
                        {promoPosts.map((post, index) => (
                            <NewsPromoItem {...post} key={post.id} index={index} locale={locale} />
                        ))}
                    </ul>
                )}

                {regPosts.length > 0 && (
                    <ul className={styles.list}>
                        {regPosts.map((post, index) => (
                            <NewsItem {...post} key={post.id} index={index} locale={locale} />
                        ))}
                    </ul>
                )}

                <LoadMore
                    ref={forwardRef}
                    isLoading={loading}
                    hasError={lastFetchFailed}
                    hasReachedEndOfData={hasFetchedAllPosts}
                    loadMoreCallback={loadMorePosts}
                />
            </section>
        );
    }
);

export default News;
